import styled from "styled-components";

export const ExplorerOnboardingTooltipContainerBox = styled.div<{bottom: number}>`
  padding: 2rem 0;
  position: fixed;
  bottom: ${props => props.bottom + 'px'};
  left: 0;
  background: linear-gradient(180deg, #171717 0%, #000000 100%);
  width: 100vw;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  
  opacity: 0;
  animation: fadeIn 0.5s forwards; 

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .explorer-menu-onboarding-button-container {
    width: 80%;
    font-size: 1.5rem;
  }
`;